import { createClient } from "@supabase/supabase-js";

// ============================================================
// DEMO BUILD CONFIG
// ------------------------------------------------------------
// 1) Point these at the SHARED "wilco demo" Supabase project
//    (the one already housing the members `mbr_` and catering
//    `cat_` demos) — NOT the real Nashville Bee Company project.
// 2) TABLE_PREFIX namespaces every table for the store demo so it
//    sits alongside the other two without collisions.
//      • Demo build  -> "store_"  (store_products, store_orders, ...)
//      • Real NBC app -> ""       (unprefixed, leave it blank)
//    If this export is removed/blank, the app falls back to no
//    prefix automatically, so the same codebase works for both.
// ============================================================
export const SUPABASE_URL = "https://hmwnbwffzxjayzktcjne.supabase.co"; // <-- swap to the shared demo project URL
const SUPABASE_KEY = "sb_publishable_DiVoYz-MZj4FNGt7Pu6T3w_hiECyCxg";   // <-- swap to the shared demo project publishable key

export const TABLE_PREFIX = "store_";

// DEMO_MODE turns on public guest access: each visitor gets their own anonymous
// Supabase session (no shared login, nobody can be kicked off). Set to false (or
// remove) for the real Nashville Bee Company app so it keeps the email/password login.
export const DEMO_MODE = true;

export const supabase = createClient(SUPABASE_URL, SUPABASE_KEY);
